import { JE_FQClaimXformSpec } from "../jsonFQContext";
import { getClaimsForStringFormat, makeTransformForStringFormat, validateJsonForStringFormat } from "./stringFormat";
import {
    JE_FCValidationNode,
    JE_JsonValidationContext
  } from '../interfaces';

export const claimFunctions = {
    stringFormat: 'stringFormat'
}

export interface JsonClaimTransformData {
    transform: string;
    transformData: any;
    getClaims: () => string[];
    makeTransform: (nodeName: string, outputClaimId: string, inputClaimMap?: {[baseId: string]: string}) => JE_FQClaimXformSpec;
}

const getClaimsMap = {
    [claimFunctions.stringFormat]: getClaimsForStringFormat
};

export const generateGetClaimsMethod = (transform: string, transformData: any) => {
    return () => getClaimsMap[transform](transformData);
}

const makeTransformMap = {
    [claimFunctions.stringFormat]: makeTransformForStringFormat
}

export const generateMakeTransformMethod = (transform: string, transformData: any, inputClaimMap?: {[baseId: string]: string}) => {
    return (nodeName: string, outputClaimId: string) => makeTransformMap[transform](nodeName, transformData, outputClaimId, inputClaimMap);
}

const validateJsonMap = {
    [claimFunctions.stringFormat]: validateJsonForStringFormat
}

export const validateTransformJson = (vCtx: JE_JsonValidationContext, vNode: JE_FCValidationNode, transform: string, transformData: any) => {
    return validateJsonMap[transform](vCtx, vNode, transformData);
}